module.exports = __webpack_public_path__ + "static/media/lotto5d_bg.7272bf11.png";